import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable, of } from "rxjs";
import { ContactPipe } from "src/app/lib/customer/pipes/contact.pipe";
import { CustomerPipe } from "src/app/lib/customer/pipes/customer.pipe";
import { ChangeCollisionEntry, CHANGE_COLLISION_DISPLAY_TYPE } from "src/app/lib/shared/classes";
import { Issue, IssueAuditWrapper } from "../../../classes";
import { IHistoryProviderService } from "../../../interfaces";
import { IssueCategoryPipe } from "../../../pipes/issue-category.pipe";
import { IssuePriorityPipe } from "../../../pipes/issue-priority.pipe";
import { IssueStatusPipe } from "../../../../shared/pipes/issue-status.pipe";
import { IssueAuditService } from "../../../services/issue-audit.service";
import { tap } from "rxjs/operators";

@Injectable()
export class IssueHistoryDialogComponentService implements IHistoryProviderService {

    audit: IssueAuditWrapper[] = [];

    pageNumber = new BehaviorSubject(1);
    pageSize = new BehaviorSubject(10);
    totalCount: number = 0;

    constructor(
        private _issueStatusPipe: IssueStatusPipe,
        private _issueCategoryPipe: IssueCategoryPipe,
        private _issuePriorityPipe: IssuePriorityPipe,
        private _contactPipe: ContactPipe,
        private _customerPipe: CustomerPipe,
        private _issueAuditService: IssueAuditService
    ) { }

    changeProvider = (oldIssue: Issue, newIssue: Issue): ChangeCollisionEntry[] => {
        let output = [];
        if (oldIssue && newIssue) {
            if (oldIssue.issuetitle !== newIssue.issuetitle) output.push({ 'attribute': of('Titel'), 'oldValue': of(oldIssue.issuetitle), 'newValue': of(newIssue.issuetitle), 'type': CHANGE_COLLISION_DISPLAY_TYPE.STRING } as ChangeCollisionEntry);
            if (oldIssue.issuestate !== newIssue.issuestate) output.push({ 'attribute': of('Status'), 'oldValue': this._issueStatusPipe.transform(oldIssue.issuestate), 'newValue': this._issueStatusPipe.transform(newIssue.issuestate), 'type': CHANGE_COLLISION_DISPLAY_TYPE.STRING } as ChangeCollisionEntry);
            if (oldIssue.issuecategory !== newIssue.issuecategory) output.push({ 'attribute': of('Kategorie'), 'oldValue': this._issueCategoryPipe.transform(oldIssue.issuecategory), 'newValue': this._issueCategoryPipe.transform(newIssue.issuecategory), 'type': CHANGE_COLLISION_DISPLAY_TYPE.STRING } as ChangeCollisionEntry);
            if (oldIssue.issuepriority !== newIssue.issuepriority) output.push({ 'attribute': of('Priorität'), 'oldValue': this._issuePriorityPipe.transform(oldIssue.issuepriority), 'newValue': this._issuePriorityPipe.transform(newIssue.issuepriority), 'type': CHANGE_COLLISION_DISPLAY_TYPE.STRING } as ChangeCollisionEntry);
            if (oldIssue.issueescalation !== newIssue.issueescalation) output.push({ 'attribute': of('Wunschdatum'), 'oldValue': of(oldIssue.issueescalation), 'newValue': of(newIssue.issueescalation), 'type': CHANGE_COLLISION_DISPLAY_TYPE.DATE } as ChangeCollisionEntry);
            if (oldIssue.commercialcontactpersonalid !== newIssue.commercialcontactpersonalid) output.push({ 'attribute': of('Ansprechpartner (geschäftlich)'), 'oldValue': this._contactPipe.transform(oldIssue.commercialcontactpersonalid), 'newValue': this._contactPipe.transform(newIssue.commercialcontactpersonalid), 'type': CHANGE_COLLISION_DISPLAY_TYPE.STRING } as ChangeCollisionEntry);
            if (oldIssue.localcontactpersonalid !== newIssue.localcontactpersonalid) output.push({ 'attribute': of('Ansprechpartner (vor Ort)'), 'oldValue': this._contactPipe.transform(oldIssue.localcontactpersonalid), 'newValue': this._contactPipe.transform(newIssue.localcontactpersonalid), 'type': CHANGE_COLLISION_DISPLAY_TYPE.STRING } as ChangeCollisionEntry);
            if (oldIssue.issuecustomer !== newIssue.issuecustomer) output.push({ 'attribute': of('Kunde'), 'oldValue': this._customerPipe.transform(oldIssue.issuecustomer), 'newValue': this._customerPipe.transform(newIssue.issuecustomer), 'type': CHANGE_COLLISION_DISPLAY_TYPE.STRING } as ChangeCollisionEntry);
        }
        return output;
    }

    deleteIssueAuditWrapper(wrapper: IssueAuditWrapper): Observable<Object> {
        return this._issueAuditService.deleteIssueAuditWrapperAsFinished(wrapper.guid).pipe(tap(() => {
            let index = this.audit.indexOf(wrapper);
            if(index > -1){
                this.audit.splice(index, 1);
                this.totalCount--;
            }
        }));
    }

}
